import React from 'react';
import loadable from '@loadable/component';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const Footer = loadable(p => import(`@quikr/ui/theme/${p.host}/components/Footer`));

const CopyRight = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.Neutral[300]};
  padding: 24px 0;
  @media screen and (max-width: 768px) {
    padding: 24px 12px;
  }
`;

const FooterWrapper = ({ host }) => {
  const { pathname } = useLocation();
  const renderFooter = url => {
    switch (url) {
      case '/post-ad':
        return (
          <CopyRight className="dF jcC fwM">
            Copyright © 2008 - {new Date().getFullYear()} Quikr India Private Limited
          </CopyRight>
        );
      case '/promo/quikreasy/renew-your-pack':
        return <Footer host={host} />;
      default:
        return <Footer host={host} />;
    }
  };
  return renderFooter(pathname);
};

export default FooterWrapper;
